<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <card-component
        :title="formCardTitle"
        icon="file-edit"
        class="tile is-child"
      >
        <registry-entries-add
          ref="entryForm"
          @handleAddRegistryEntry="handleAddRegistryEntry"
          @handleEditRegistryEntry="handleEditRegistryEntry"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import RegistryEntries from "@/services/registryEntries.service";
import { notify } from "@/helpers/notify";
import TitleBar from "@/components/TitleBar";
import CardComponent from "@/components/CardComponent";
import RegistryEntriesAdd from "../../components/registry/registryEntries-add.vue";

export default {
  name: "RegistryEntry",
  components: { TitleBar, CardComponent, RegistryEntriesAdd },
  data() {
    return {
      editMode: false,
    };
  },

  methods: {
    handleAddRegistryEntry(registryEntry) {
      const { addRegistryEntry } = RegistryEntries;

      addRegistryEntry(registryEntry)
        .then((response) => {
          // Serviciul inghite erorile si intoarce obiectul de eroare axios,
          // deci raspunsurile de eroare ajung aici, nu in .catch.
          const errorStatus = pathOr(null, ["response", "status"], response);
          // Mesajul trimis de API, cand exista: de exemplu departamentul refuzat (SEC-17).
          const apiMessage = pathOr(
            null,
            ["response", "data", "message"],
            response
          );

          if (errorStatus === 409) {
            // Rezervarea aleasa nu mai poate fi folosita. Operatorul ramane in formular,
            // cu selectia revenita la "fara numar rezervat" si lista reincarcata.
            const message = pathOr(
              "Rezervarea aleasa nu mai poate fi folosita. Alegeti alt numar.",
              ["response", "data", "message"],
              response
            );
            notify.error(this, message);
            this.$refs.entryForm.resetReservedNumberSelection();
            return;
          }

          // 400 fara errorCode: departamentul refuzat (SEC-17). Erorile numerelor rezervate au
          // errorCode si raman pe mesajul generic de mai jos, ca inainte.
          const apiErrorCode = pathOr(
            null,
            ["response", "data", "errorCode"],
            response
          );
          if (errorStatus === 400 && apiMessage && !apiErrorCode) {
            notify.error(this, apiMessage);
            return;
          }

          if (errorStatus === 403) {
            // Fara mesaj: refuzul numerelor rezervate. Cu mesaj: departamentul refuzat (SEC-17).
            notify.error(
              this,
              apiMessage || "Nu aveti permisiunea de a folosi numere rezervate."
            );
            return;
          }

          if (errorStatus === 503) {
            notify.error(this, "Registrul este ocupat. Reincercati.");
            return;
          }

          // Numarul primit nu mai trebuie comparat cu cel cerut: serverul il copiaza
          // chiar din rezervarea identificata prin Id.
          if (response.status == "200") {
            notify.success(this, "Inregistrarea a fost adaugata.");
            this.$router.push({ path: "/RegistryEntries" });
          } else {
            notify.error(this, "Eroare la adaugarea inregistrarii.");
          }
        })
        .catch(() => {
          notify.error(this);
        });
    },
    async handleEditRegistryEntry(registryEntry) {
      const { handleEditRegistryEntry } = RegistryEntries;
      let response;
      try {
        response = await handleEditRegistryEntry(registryEntry);
      } catch (error) {
        notify.error(this, "Eroare la modificarea inregistrarii.");
        return;
      }

      // Serviciul inghite erorile si intoarce obiectul de eroare axios, deci o modificare
      // refuzata (400, 403, 404) ajunge aici. Operatorul ramane in formular.
      const status = pathOr(null, ["status"], response);
      if (status >= 200 && status < 300) {
        notify.success(this, "Inregistrarea a fost modificata.");
        this.$router.push({ path: "/RegistryEntries" });
        return;
      }

      notify.error(
        this,
        pathOr(
          "Eroare la modificarea inregistrarii.",
          ["response", "data", "message"],
          response
        )
      );
    },
  },
  computed: {
    titleStack() {
      const parent = { label: "Registratura", to: "/RegistryEntries" };
      if (this.editMode) {
        return [parent, "Editare document"];
      } else {
        return [parent, "Adaugare document"];
      }
    },
    formCardTitle() {
      if (this.editMode) {
        return "Editare document";
      } else {
        return "Adaugare document";
      }
    },
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    if (id) {
      this.editMode = true;
    } else {
      // this.announcement.date = new Date();
    }
  },
};
</script>
